import axios, { AxiosResponse } from "axios";
import {IOfferModel } from "./OfferModel";
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'


const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const OFFER_CREATE_URL = `${API_URL}api/v1/definition/offer/create`;
export const OFFER_GET_ALL_URL = `${API_URL}api/v1/definition/offer/all`;
export const OFFER_DELETE_URL = `${API_URL}api/v1/definition/offer/delete/`;
export const OFFER_UPDATE_URL = `${API_URL}api/v1/definition/offer/update/`;


export function createOffer(OfferId: IOfferModel) {
  return axios.post(OFFER_CREATE_URL, OfferId)
}

export function updateOffer(OfferId: IOfferModel) {
  return axios.patch(OFFER_UPDATE_URL , OfferId)
}

export function deleteOffer(OfferId: number | string) {
  return axios.delete(OFFER_DELETE_URL +OfferId)
}

export async function getAllOffers(
  page = 0, 
  size = 10, 
  sort: string = 'createdDate', 
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IOfferModel >>>> {
  return axios.get(OFFER_GET_ALL_URL, {
    params: { page, size, sort, order }
  });
}